import React, { useState } from "react";
import { Select } from "antd";
import { debounce } from "lodash";
import FloatLabel from "../FloatingLabel";
import { onecodeAPI } from "../../AppConfig";
const { Option } = Select;

const DyanamicSelectBox = (props) => {
  const { item, field, form, placeholder, hash, formData, preFormValues,readOnly } =
    props;
  const { code } = item;
  const { value, name } = field;

  const { setFieldValue, values, handleBlur, validateForm } = form;

  const [localValue, setLocalValue] = useState("");

  const [result, setResult] = useState([]);

  React.useEffect(() => {

    if (value && value != null) {
      setLocalValue(value && value != null ? value : "");

      if (result.length == 0) {
        const pre = preFormValues.filter((p) => p.fieldId == item.id);
        if (pre.length > 0) {
          const dummyResult = {
            fieldCode: item.code,
            ocFieldId: item.id,
            optionId: pre[0].optionId,
            optionValue: pre[0].optionValue,
          };
          let dummyResultArray = [dummyResult].concat(result);

          const unqResultArray = new Map();
          dummyResultArray.forEach((p) => unqResultArray.set(p.optionId, p));
          setResult([...unqResultArray.values()]);
        }
      }
    } else {
      setLocalValue("");
    }
  }, [value]);
  const debounceFn = React.useCallback(debounce(handleDebounceFn, 400), []);

  async function handleDebounceFn(searchText, ocFieldId) {
    let res = [];
    try {
      if (searchText && searchText != "") {
        const resData = await onecodeAPI.get(
          `public/autocomplete?letter=${searchText}&ocFieldId=${ocFieldId}`,
          {
            hash: hash,
          }
        );
        res = resData.data;
      }
    } catch (error) {
      console.log(error);
    }

    if (code == "designation") {
      setResult([
        {
          createdAt: null,
          fieldCode: "designation",
          id: null,
          isDeleted: false,
          ocFieldId: 724,
          optionId: "1",
          optionValue: "Others",
          optionValueTranslationId: null,
          orderNo: null,
          updatedAt: null,
          optionCode: null,
        },
      ]);
  } 

        if (code === "industryName") {
          setResult([
            {
              createdAt: null,
              fieldCode: "industry",
              id: null,
              isDeleted: false,
              ocFieldId: 794,
              optionId: "98",
              optionValue: "Other Industry",
              optionValueTranslationId: null,
              orderNo: null,
              updatedAt: null,
              optionCode: null,
            },
          ]);
      }

    if (res.length > 0) {
      setResult(res);
    } else if (code == "OtherCompanyName") {
      setResult([
        {
          createdAt: null,
          fieldCode: "OtherCompanyName",
          id: null,
          isDeleted: false,
          ocFieldId: 562,
          optionId: "99999",
          optionValue: "Others",
          optionValueTranslationId: null,
          orderNo: null,
          updatedAt: null,
        },
      ]);
    } else if (code == "companyName") {
        setResult([
          {
            createdAt: null,
            fieldCode: "companyName",
            id: null,
            isDeleted: false,
            ocFieldId: 600,
            optionId: "c",
            optionValue: "Others",
            optionValueTranslationId: null,
            orderNo: null,
            updatedAt: null,
          },
        ]);
    } else if (code == "NameOfCompanyBusiness") {
      setResult([
        {
          createdAt: null,
          fieldCode: "NameOfCompanyBusiness",
          id: null,
          isDeleted: false,
          ocFieldId: 723,
          optionId: "1",
          optionValue: "Others",
          optionValueTranslationId: null,
          orderNo: null,
          updatedAt: null,
          optionCode: null,
        },
      ]);
  }
  }

  const handleSearch = async (searchText, ocFieldId) => {
    debounceFn(searchText, ocFieldId);
  };

  const handleDebounceValidateFn = () => {
    validateForm();
  };

  const debounceValidateFn = React.useCallback(
    debounce(handleDebounceValidateFn, 400),
    []
  );

  return (
    <FloatLabel label={placeholder} name={name} value={value || null}>
      <Select
        name={name}
        style={{ width: "100%"}}
        // size="large"
        bordered
        showSearch
        allowClear
        filterOption={false}
        notFoundContent={""}
        onSearch={(searchValue) => handleSearch(searchValue, name)}
        disabled = { readOnly }
        onChange={(selectValues, selectValuesOptions) => {
          if (selectValues != null) {
            setFieldValue(name, selectValuesOptions.name);
        // onChange={(selectValues, selectValuesOptions) => {
        //   if (selectValues != null) {
        //     setFieldValue(name, selectValues);
            setFieldValue(name + "_name_", selectValuesOptions.name);
          } else {
            setFieldValue(name, "");
            setFieldValue(name + "_name_", "");
          }
          if (code == "OtherCompanyName") {
            const dependedField = formData.filter(
              (formItem) => formItem.code == "CompanyCode"
            );
            if (dependedField && dependedField.length > 0) {
              if (selectValues) {
                setFieldValue(
                  dependedField[0].id,
                  selectValuesOptions.id ? selectValuesOptions.id : selectValuesOptions.name
                  // selectValuesOptions.id ? selectValuesOptions.id : selectValues
                );
              } else {
                setFieldValue(dependedField[0].id, "");
              }
            }
          }

          if(code === "NameOfCompanyBusiness"){
            const dependedField = formData.filter(
              (formItem) => formItem.code === "EmploymentType"
            );
            if (dependedField && dependedField.length > 0) {
              if (values['637_name_'] === 'Self Employed') {
                setFieldValue("Others", "");
              }
            }
          }

          if(code === "designation"){
            const dependedField = formData.filter(
              (formItem) => formItem.code === "EmploymentType"
            );
            if (dependedField && dependedField.length > 0) {
              if (values['637_name_'] === 'Self Employed') {
                setFieldValue("Others", "");
              }
            }
          }

          if (code == "ResCity" || code == "ResPIN") {
            let cloneData = false;
            const dependedField = formData.filter(
              (formItem) => formItem.code == "PermAddrSameAsResAddr"
            );
            if (dependedField && dependedField.length > 0) {
              if (values[`${dependedField[0].id}`]) {
                cloneData = true;
              }
            }

            if (cloneData) {
              if (code == "ResCity") {
                const dependedField = formData.filter(
                  (formItem) => formItem.code == "PermCity"
                );
                if (dependedField && dependedField.length > 0) {
                  setFieldValue(
                    `${dependedField[0].id}`,
                    selectValuesOptions.name
                  );
                }
              }

              if (code == "ResPIN") {
                const dependedField = formData.filter(
                  (formItem) => formItem.code == "PermPin"
                );
                if (dependedField && dependedField.length > 0) {
                  setFieldValue(
                    `${dependedField[0].id}`,
                    selectValuesOptions.name
                  );
                }
              }
            }
          }
        }}
        onClear={() => {
          debounceValidateFn();
        }}
        onSelect={() => {
          debounceValidateFn();
        }}
        onBlur={handleBlur(name)}
        value={localValue}
      >
        {result.map((option, i) => (
          <Option
            id={option.optionId}
            key={option.optionId + "@" + i}
            value={option.optionId}
            name={option.optionValue}
          >
            {option.optionValue}
          </Option>
        ))}
      </Select>
    </FloatLabel>
  );
};

export default DyanamicSelectBox;
